import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import RLCompetition from '../components/rl/RLCompetition';

function CompetitionPage() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          🏆 RL Agent Competitions
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Watch your trained agents compete in real-time trading battles
        </Typography>
      </Box>

      <RLCompetition />
    </Container>
  );
}

export default CompetitionPage;